import { useEffect, useState } from 'react';
import { onAuthStateChanged, User } from 'firebase/auth';
import { AUTH } from '../../firebase/constants';
import { useNavigate } from 'react-router-dom';
import { useAtom, useSetAtom } from 'jotai';
import { redirectAtom } from '../../atoms';

type Output =
  | { status: 'LoggedIn'; user: User }
  | { status: 'LoggedOut' }
  | { status: 'Loading' };

const useLoginRedirectEffect = (): Output => {
  const [data, setData] = useState<Output>({ status: 'Loading' });
  const navigate = useNavigate();
  const [redirect, setRedirect] = useAtom(redirectAtom);

  useEffect(() => {
    const path = window.location.pathname;
    onAuthStateChanged(AUTH, (user) => {
      if (!user) {
        navigate('/login');
        setData({ status: 'LoggedOut' });
        setRedirect(path);
      } else {
        if (redirect) {
          navigate(redirect);
          setRedirect('');
        }
        setData({ status: 'LoggedIn', user });
      }
    });
  }, []);

  return data;
};

export default useLoginRedirectEffect;
